export default __webpack_public_path__ + "static/media/support.801e88c8.svg";